import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {prlAuthentificationGuard} from '../../shared/services/prl-authentification-guard';
import {PrlErrorPageComponent} from './prl-error-page/prl-error-page.component';

const routes: Routes = [
    {
        path: '404',
        component: PrlErrorPageComponent,
        canActivate: [prlAuthentificationGuard],
        data: {message: 'label.error.page.not.found'}
    },
    {
        path: '403',
        component: PrlErrorPageComponent,
        canActivate: [prlAuthentificationGuard],
        data: {message: 'label.error.page.forbidden'}
    },
    {
        path: '500',
        component: PrlErrorPageComponent,
        canActivate: [prlAuthentificationGuard],
        data: {message: 'label.error.page.internal.server.error'}
    },
    {
        path: '503',
        component: PrlErrorPageComponent,
        canActivate: [prlAuthentificationGuard],
        data: {message: 'label.error.page.service.unavailable'}
    },
    {
        path: '504',
        component: PrlErrorPageComponent,
        canActivate: [prlAuthentificationGuard],
        data: {message: 'label.error.page.gateway.timeout'}
    },
    {
        path: '**',
        redirectTo: '/404'
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PrlErrorPageRoutingModule {
}

